import React, { useState, useEffect, useRef } from 'react';

import { Container } from '@material-ui/core';
import { LOGOUT } from 'ConstComponents';
import { SelectReverseByFilter as SELECT_FILTER } from 'Components/Api/OverdraftApi';
import ReactTable from 'Components/ReactTable/ReactTable';

import { ADMIN } from 'Components/Helper/UsertypeCode';
import { CustomModal } from 'Components/Modal/CustomModal';

import { ReverseAction } from 'Pages/InnerPages/Overdraft/ReverseAction';
import HOCLoader from 'Components/Loader/HOCLoader';

const CustomContainer = HOCLoader(Container);

export const OverdraftReverseReport = () => {
    const formRef = useRef();

    const [requests, setRequests] = useState([]);

    const [mainColumns, setMainColumns] = useState([]);
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [severity, setSeverity] = useState('success');

    const [currentUserTypeID] = useState(
        parseInt(localStorage.getItem('UserTypeID'))
    );

    const [loading, setLoading] = useState(false);

    const [OverdraftMasterID, setOverdraftMasterID] = useState(0);
    const [isOpen, setIsOpen] = useState(false);

    const selectRequests = async () => {
        setLoading(true);
        const response = await SELECT_FILTER();

        setLoading(false);

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setIsError(true);
            setSeverity('error');
            setResponseMessage(response.data);

            return;
        }

        var data = JSON.parse(response.data);

        setRequests(data.data);
    };

    useEffect(() => {
        selectRequests();
        createColumns();
    }, []);

    const createColumns = () => {
        var columns = [];

        columns.push({
            label: '#',
            name: 'OverdraftMasterID',
            srno: true
        });

        columns.push({
            label: 'Date',
            name: 'DOC'
        });

        columns.push({
            label: 'User',
            name: 'User'
        });

        columns.push({
            label: 'Wallet',
            name: 'Wallet'
        });
        columns.push({
            label: 'Balance',
            name: 'WalletBalance',
            numeric: true
        });
        columns.push({
            label: 'OD Amount',
            name: 'Amount',
            numeric: true
        });

        if (currentUserTypeID === ADMIN) {
            columns.push({
                label: 'Action',
                name: 'OverdraftMasterID',
                statusIndex: 6,
                button: true,
                callback: (value) => {
                    setIsOpen(true);
                    setOverdraftMasterID(value);
                }
            });
        }

        setMainColumns(columns);
    };

    return (
        <CustomContainer
            isLoading={loading}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            {isOpen ? (
                <CustomModal
                    isOpen={isOpen}
                    title="Reverse Action"
                    width="75%"
                    onDismissCallback={(value) => {
                        setIsOpen(value);
                        selectRequests();
                    }}
                >
                    <ReverseAction
                        OverdraftMasterID={OverdraftMasterID}
                        onDismissCallback={(value) => {
                            setIsOpen(value);
                            selectRequests();
                        }}
                    />
                </CustomModal>
            ) : null}

            <ReactTable data={requests} columns={mainColumns} />
        </CustomContainer>
    );
};
